/**
 * Rozet/Badge yapılandırması
 *
 * Oyun tarzları: src/config/oyunTarzlariFromGame.json
 * Oyuncu kimyaları: src/config/kimyalarFromGame.json (açıklamasız, sadece isim)
 * Takım/ülke/lig: public/icons/badges/ altına görsel ekleyip ilgili diziye satır ekle
 */

import kimyalarFromGame from './kimyalarFromGame.json';
import oyunTarzlariFromGame from './oyunTarzlariFromGame.json';

export interface BadgeItem {
  id: string;
  name: string;
  image: string;
  description?: string; // Sadece oyuncu tarzları için - tıklandığında gösterilecek açıklama
}

export type ChemistryCategory = 'HÜCUM' | 'ORTA SAHA' | 'DEFANS' | 'ÖZEL' | 'KALECİ';

export interface ChemistryItem extends BadgeItem {
  kategori: ChemistryCategory;
}

export const BADGES_CONFIG = {
  teams: [
    { id: 'galatasaray', name: 'Galatasaray', image: '/icons/badges/teams/galatasaray.png' },
    { id: 'fenerbahce', name: 'Fenerbahçe', image: '/icons/badges/teams/fenerbahce.png' },
    { id: 'besiktas', name: 'Beşiktaş', image: '/icons/badges/teams/besiktas.png' },
    { id: 'trabzonspor', name: 'Trabzonspor', image: '/icons/badges/teams/trabzonspor.png' },
    { id: 'istanbul-basaksehir', name: 'İstanbul Başakşehir', image: '/icons/badges/teams/istanbul-basaksehir.png' },
    { id: 'samsunspor', name: 'Samsunspor', image: '/icons/badges/teams/samsunspor.png' },
    { id: 'caykur-rizespor', name: 'Çaykur Rizespor', image: '/icons/badges/teams/caykur-rizespor.png' },
    { id: 'goztepe', name: 'Göztepe', image: '/icons/badges/teams/goztepe.png' },
    { id: 'alanyaspor', name: 'Alanyaspor', image: '/icons/badges/teams/alanyaspor.png' },
    { id: 'kasimpasa', name: 'Kasımpaşa', image: '/icons/badges/teams/kasimpasa.png' },
    { id: 'konyaspor', name: 'Konyaspor', image: '/icons/badges/teams/konyaspor.png' },
    { id: 'kayserispor', name: 'Kayserispor', image: '/icons/badges/teams/kayserispor.png' },
    { id: 'antalyaspor', name: 'Antalyaspor', image: '/icons/badges/teams/antalyaspor.png' },
    { id: 'adana-demirspor', name: 'Adana Demirspor', image: '/icons/badges/teams/adana-demirspor.png' },
    { id: 'hatayspor', name: 'Hatayspor', image: '/icons/badges/teams/hatayspor.png' },
    { id: 'bodrum-fk', name: 'Bodrum FK', image: '/icons/badges/teams/bodrum-fk.png' },
    { id: 'sivasspor', name: 'Sivasspor', image: '/icons/badges/teams/sivasspor.png' },
    { id: 'gaziantep-fk', name: 'Gaziantep FK', image: '/icons/badges/teams/gaziantep-fk.png' },
    { id: 'eyupspor', name: 'Eyüpspor', image: '/icons/badges/teams/eyupspor.png' },
  ] as BadgeItem[],
  countries: [
    { id: 'tr', name: 'Türkiye', image: '/icons/badges/countries/tr.png' },
  ] as BadgeItem[],
  leagues: [
    { id: 'superlig', name: 'Türkiye Süper Lig', image: '/icons/badges/leagues/super-lig.png' },
  ] as BadgeItem[],
  styles: oyunTarzlariFromGame.map(({ id, name, image, description }) => ({
    id,
    name,
    image,
    description,
  })) as (BadgeItem & { description: string })[],
  chemistries: kimyalarFromGame as ChemistryItem[],
};
